//
//
//
//
//
//
//
//
//

export default {
  name: 'Weforsys-uploadBtn',
  data: function data() {
    return {
      loading: false
    };
  },
  props: {
    url: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: '导入'
    },
    buttonType: {
      type: String,
      default: 'text'
    }
  },
  methods: {
    beforeUpload: function beforeUpload() {
      this.loading = true;
    },
    handleSuccess: function handleSuccess(res) {
      this.loading = false;
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success',
          duration: 1000
        });
        this.$emit('on-success');
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
          duration: 1000
        });
      }
    }
  }
};